// components/Publications.js
// import React, { useEffect } from 'react';

function Publications() {

  return (
    <article id="publications" className="wrapper style3">
      <div className="container">
        <header>
          <h2>Publications</h2>
        </header>
        {/* <div className="row">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="col-4 col-6-medium col-12-small">
              <article className="box style2">
                <a href="#" className="image featured"><img src={`images/pic0${i + 1}.jpg`} alt="" /></a>
                <h3><a href="#">Project {i + 1}</a></h3>
                <p>Ornare nulla proin odio consequat.</p>
              </article>
            </div>
          ))}
        </div> */}
      </div>
    </article>
  );
}

export default Publications;